// STYLES
import { CookiesPageContainer, TitleContainer } from "./CookieModuleStyled";

// LIBRARIES
import { useSelector } from "react-redux";
import { selectLanguage } from "slices/LanguageSlice/languageSlice";

// MISC
import { COLORS } from "constants/variables";
import useCookieConsent from "./hooks/useCookieConsent";
import {
  cookieInformation,
  initialAnalyticsCookies,
  initialNecessaryCookies,
} from "./config/cookieModuleConfig";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import CookiesCard from "view/CookieModule/components/CookiesCard/CookiesCard";
import CookiesPreferencesModal from "./components/CookiePreferencesModal/CookiesPreferencesModal";

// CONFIGURATION

const CookieModule = () => {
  // PROPERTIES
  const {
    showModal,
    necessaryCookies,
    analyticsCookies,
    setNecessaryCookies,
    setAnalyticsCookies,
    handleSaveSettings,
    handleManageSettings,
    setShowModal,
  } = useCookieConsent(initialNecessaryCookies, initialAnalyticsCookies);

  // API REQUESTS

  // LIBRARY CONSTANTS
  const currentLanguage = useSelector(selectLanguage);

  // STATE CONSTANTS

  // LIFE CYCLE

  // EVENT HANDLERS
  return (
    <CookiesPageContainer>
      <TitleContainer>
        <CustomText
          type={TextType.H1}
          text="Cookie-uri"
          color={COLORS.RaisinBlack}
        />
      </TitleContainer>
      {cookieInformation.map((info, index) => (
        <CookiesCard
          key={index}
          title={info.title}
          texts={info.texts}
          list={info.list}
          hasButton={info.hasButton}
          onClick={handleManageSettings}
        />
      ))}
      <CookiesPreferencesModal
        showModal={showModal}
        setShowModal={setShowModal}
        necessaryCookies={necessaryCookies}
        analyticsCookies={analyticsCookies}
        setNecessaryCookies={setNecessaryCookies}
        setAnalyticsCookies={setAnalyticsCookies}
        handleSaveSettings={handleSaveSettings}
        language={currentLanguage}
      />
    </CookiesPageContainer>
  );
};

export default CookieModule;
